import { createSlice } from '@reduxjs/toolkit';
import { ICategoryUI } from 'types/category';
import { IServiceUI } from 'types/service';
import { IStaffUI } from 'types/staff';
import actions from './actions';
import { IShopInfoResData } from 'types/shop';
import { ICouponResItem, IStaffResItem } from 'types/response';
import { IDepositSetting } from 'types/deposit';
import { IPromotionDetail } from 'types/promotion';
import { IGalleryItem } from 'types/gallery';
import { IScheduleBooking, ISchedulerSalonResData } from 'types/appointment';

const _scheduleBooking = {
  ['Sun']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Sat']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Fri']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Thu']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Wed']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Tue']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
  ['Mon']: {
    enable: true,
    endTime: '21:00',
    startTime: '08:00',
  },
};

const NAME_REDUCER = 'shop';

export type IStateShop = {
  staffs: IStaffUI[],
  categories: ICategoryUI[],
  allServices: IServiceUI[],
  shopInfo: IShopInfoResData | null,
  couponData: ICouponResItem[],
  depositSetting: IDepositSetting | null,
  promotion: IPromotionDetail | null,
  gallery: IGalleryItem[],
  salonWorking: ISchedulerSalonResData | null,
  scheduleBooking: IScheduleBooking | null,
  availableStaffByTimeSlot: IStaffUI[],
  isStaffLoading: boolean,
}
const initialState: IStateShop = {
  staffs: [],
  categories: [],
  allServices: [],
  shopInfo: null,
  couponData: [],
  depositSetting: null,
  promotion: null,
  gallery: [],
  salonWorking: null,
  scheduleBooking: _scheduleBooking,
  availableStaffByTimeSlot: [],
  isStaffLoading: false,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.availableStaffByTimeSlot.fetch, (state, { payload }) => {
        state.availableStaffByTimeSlot = [];
        state.isStaffLoading = true;
      })
      .addCase(actions.availableStaffByTimeSlot.success, (state, { payload }) => {
        state.availableStaffByTimeSlot = (state.staffs.filter(o => payload.find(p => p.id?.toString() === o.id?.toString()))) as unknown as IStaffUI[];
        state.isStaffLoading = false;
      })
      .addCase(actions.availableStaffByTimeSlot.fail, (state, { payload }) => {
        state.availableStaffByTimeSlot = [];
        state.isStaffLoading = false;
      })
      .addCase(actions.salonScheduler.success, (state, { payload }) => {
        state.salonWorking = payload;
        const _scheduleBooking = {
          ['Sun']: {
            enable: !!payload.sunday,
            endTime: payload.sunEndTime,
            startTime: payload.sunStartTime,
          },
          ['Sat']: {
            enable: !!payload.saturday,
            endTime: payload.satEndTime,
            startTime: payload.satStartTime,
          },
          ['Fri']: {
            enable: !!payload.friday,
            endTime: payload.friEndTime,
            startTime: payload.friStartTime,
          },
          ['Thu']: {
            enable: !!payload.thursday,
            endTime: payload.thuEndTime,
            startTime: payload.thuStartTime,
          },
          ['Wed']: {
            enable: !!payload.wednesday,
            endTime: payload.wedEndTime,
            startTime: payload.wedStartTime,
          },
          ['Tue']: {
            enable: !!payload.tuesday,
            endTime: payload.tueEndTime,
            startTime: payload.tueStartTime,
          },
          ['Mon']: {
            enable: !!payload.monday,
            endTime: payload.monEndTime,
            startTime: payload.monStartTime,
          },
        };
        state.scheduleBooking = _scheduleBooking;
      })
      .addCase(actions.galleries.success, (state, { payload }) => {
        state.gallery = payload;
      })
      .addCase(actions.promotion.success, (state, { payload }) => {
        state.promotion = payload;
      })
      .addCase(actions.depositSetting.success, (state, { payload }) => {
        // state.depositSetting = payload;
        // state.depositSetting = null;
      })
      .addCase(actions.category.success, (state, { payload }) => {
        state.categories = payload;
        const services: IServiceUI[] = [];
        state.categories.map(cate => {
          cate.services.map(s => {
            services.push({
              ...s,
              cateId: cate.id,
            });
          });
        });
        state.allServices = services;
      })
      .addCase(actions.staff.success, (state, { payload }) => {
        state.staffs = payload;
      })
      .addCase(actions.coupons.success, (state, { payload }) => {
        state.couponData = payload;
      })
      .addCase(actions.shopInfo.success, (state, { payload }) => {
        state.shopInfo = payload;
      })
      ;
  },
});

const shopReducer = Slice.reducer;
export default shopReducer;
